import { apiPostSignUpUserCreateFormat } from 'api/auth/signup-create-user-format';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { getRandomColor } from '../core/utils';
import { auth, database, messaging } from '../firebase/firebase';

const AuthContext = React.createContext()

const { REACT_APP_BACKEND_API_URL: baseUrl } = process.env;

export function useAuth() {
  return useContext(AuthContext)
}

//Main Function
function AuthProvider({ children, localStorageToken }) {
  const [currentUser, setCurrentUser] = useState();
  const [isCurrentUserAdmin, setIsCurrentUserAdmin] = useState(false);
  const [stripeSubscription, setStripeSubscription] = useState(null);
  const [mastermindOnboardingGroups, setMastermindOnboardingGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userAuthToken, setUserAuthToken] = useState(localStorageToken);

  const detachListeners = () => {
    const uID = auth.currentUser.uid;
    database.ref(`/Users/${uID}/PendingInvites/`).off();
    database.ref(`/Users/${uID}/Partners/`).off();
    database.ref(`/Users/${uID}/Invitations/`).off();
    database.ref(`/Users/${uID}/Ongoing/`).off();
    database.ref(`/Users/${uID}/Recommended/`).off();
    database.ref(`/Diagnostics/${uID}`).off();
  };

  //signup method
  async function Signup(email, password, firstName, lastName) {
    const user = await auth.createUserWithEmailAndPassword(email, password)
    let token = ''
    try {
      token = await messaging.getToken();
      await user.user.updateProfile({
        displayName: `${firstName} ${lastName}`
      })
    } catch (err) {
      console.log('Error on getting notification permissions', err)
    }
    try {
      await apiPostSignUpUserCreateFormat({
        email: email,
        Name: `${firstName} ${lastName}`,
        uid: auth.currentUser.uid
      });
    } catch (e) {
      console.log('Error on creating user profile data.', e)
    }
    const userId = auth.currentUser.uid;
    const userPayload = {
      BasicInfo: {
        Email: email,
        Username: `${firstName} ${lastName}`,
        AvatarColor: getRandomColor(),
        companyName: ''
      },
      CreatedAt: new Date(auth.currentUser.metadata.creationTime).getTime(),
      isNewUser: true,
      LastOnline: Date.now(),
      LastDailyQAVisited: Date.now(),
      deviceToken: null,
      Profile: {
        Address: '',
        ShortBio: '',
        Milestones: {
          milestone1: '',
          milestone2: '',
          milestone3: '',
        },
        Specialities: {
          specialities1: '',
          specialities2: '',
          specialities3: '',
        },
      },
    }
    if (token) {
      userPayload.deviceToken = token
    }
    await database.ref(`/Users/${userId}`).update(userPayload);
    await database.ref(`/UnGroupedUser/${userId}/`).update({
      CompanyIndustry: '',
      CompanyStage: '',
      FounderRace: '',
      Gender: ''
    })
    return user
  }

  //login method
  async function Login(email, password) {
    try {
      await auth.signInWithEmailAndPassword(email, password);

      const token = await messaging.getToken();
      console.log('token : ', token);
      await database
        .ref('/Users/' + auth.currentUser.uid + '/deviceToken/')
        .update({ [token]: true });
      return {
        uid: auth.currentUser.uid,
        lastSignInTime: auth.currentUser.metadata.lastSignInTime
      };
    } catch (error) {
      console.log(error);
      switch (error.code) {
        case 'auth/invalid-email':
          return {
            error: 'Invalid email address format.',
          };
        case 'auth/user-not-found':
        case 'auth/wrong-password':
          return {
            error: 'Invalid email address or password.',
          };
        case 'auth/too-many-requests':
          return {
            error: 'Too many request. Try again in a minute.',
          };
        default:
          return {
            error: 'Check your internet connection.',
          };
      }
    }
  }

  //logout method
  async function Logout(email, password) {
    try {
      const token = await messaging.getToken();
      await database
        .ref('/Users/' + auth.currentUser.uid + '/deviceToken/')
        .update({ [token]: false });
      detachListeners();
      setStripeSubscription(null)
      localStorage.removeItem('framewrk_user_token');
      await auth.signOut();
      return {};
    } catch (e) {
      return { error: e };
    }
  }

  async function recover(email) {
    await auth.sendPasswordResetEmail(email)
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async user => {
      setCurrentUser(user);
      if (user) {
        const idToken = await user.getIdToken()
        const url = `${baseUrl}/users/me`;
        const response = await axios.get(url, { headers: { Authorization: `Bearer ${idToken}` } });
        setIsCurrentUserAdmin(response?.data?.isAdmin === 1);
        setStripeSubscription(response?.data?.subscription);
        // Disabling New user onboarding UI functionality as suggested by zach (TODO : add notification and then show UI instead of directly showing UI)
        // if (response?.data?.isListShow) {
        //   const bothMastermindGroup = [response?.data?.listUserFirst, response?.data?.listUserSecond];
        //   setMastermindOnboardingGroups(bothMastermindGroup?.filter((mg) => mg));
        // } else {
        //   setMastermindOnboardingGroups([]);
        // }
      }
      setLoading(false)
    });
    return unsubscribe
  }, [])

  const value = {
    currentUser,
    isCurrentUserAdmin,
    stripeSubscription,
    setStripeSubscription,
    mastermindOnboardingGroups,
    setMastermindOnboardingGroups,
    Signup,
    Login,
    Logout,
    userAuthToken,
    setUserAuthToken,
    recover
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>)
}

export default AuthProvider;



